import styled from "styled-components";

export const customStylesCompanies = {
  container: (provided, state) => ({
    ...provided,
    width: "100%"
  }),

  control: (provided, state) => ({
    ...provided,
    background: "var(--primary-white)",
    borderColor: state.isFocused ? "var(--primary-blue)" : "var(--primary-dark-200)",
    borderRadius: "5px",
    minHeight: "50px",
    height: "50px",
    padding: "0 10px",
    boxShadow: state.isFocused ? "0 0 0 1px var(--primary-blue)" : "none"
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "50px",
    padding: "0 10px",
    display: "flex",
    alignItems: "center"
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    color: "var(--primary-blue)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)"
  }),

  placeholder: (provided, state) => ({
    ...provided,
    color: "var(--primary-dark-300)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)",
    margin: 0
  }),

  singleValue: (provided, state) => ({
    ...provided,
    color: "var(--primary-blue)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)"
  }),

  indicatorSeparator: (state) => ({
    display: "none"
  }),

  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "50px"
  })
};

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const FilterNavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
`;

export const FilterTitle = styled.span`
  font-size: var(--fs-base);
  font-weight: 500;
  color: var(--primary-dark);
`;
